import { render, staticRenderFns } from "./addWarnInsect.vue?vue&type=template&id=a6762a36&scoped=true&"
import script from "./addWarnInsect.vue?vue&type=script&lang=js&"
export * from "./addWarnInsect.vue?vue&type=script&lang=js&"
import style0 from "./addWarnInsect.vue?vue&type=style&index=0&id=a6762a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6762a36",
  null
  
)

export default component.exports